'use strict'

module.exports = raw

/* Stringify `raw`. */
function raw(ctx, node) {
  return node.value
}
